// extracted by mini-css-extract-plugin
export default {"app":"o6vmaWl9","top":"u54CYMCC","body":"efXhNlN4","bottom":"dVuucI1H"};